import React, { useEffect, useState } from "react";

const STORAGE_KEY = "kostpadi_theme";

function getInitialTheme() {
  const saved = localStorage.getItem(STORAGE_KEY);
  if (saved === "light" || saved === "dark") return saved;

  // fallback to system preference
  const prefersDark =
    window.matchMedia &&
    window.matchMedia("(prefers-color-scheme: dark)").matches;

  return prefersDark ? "dark" : "light";
}

export default function ThemeToggle() {
  const [theme, setTheme] = useState(getInitialTheme);

  useEffect(() => {
    document.documentElement.setAttribute("data-theme", theme);
    localStorage.setItem(STORAGE_KEY, theme);
  }, [theme]);

  function toggle() {
    setTheme((t) => (t === "dark" ? "light" : "dark"));
  }

  return (
    <button
      type="button"
      onClick={toggle}
      className="kp-theme-toggle"
      aria-label="Toggle dark/light mode"
      title="Toggle theme"
    >
      <span className="kp-theme-toggle__dot" />
      <span className="kp-theme-toggle__text">
        {theme === "dark" ? "Dark" : "Light"}
      </span>
    </button>
  );
}
